import React,{ Component } from 'react';
import { Row, Col } from 'reactstrap';

import moment from 'moment';

import SortableTable from '../../../shared/components/SortableTable';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import Button from '../../../shared/components/Button';

import capitalize from 'lodash/capitalize';

import { 
  formatStatus, 
  recursivelyLoadAllPages, 
  emojiUrlForRating,
  dayIsInPast ,
  firstNonZeroOrOne,
  alphabeticallySort,
  textContains,
  statusSort,
  daysSinceEpoch
} from '../../../shared/utils';

class ProviderSegmentationList extends Component {
  componentDidMount(){
    this.props.loadSegments();
  }

  render(){
    return (
      <Row>
        <Col xs='12'>
          <SearchableDataTable 
            items={this.props.segments}
            emptyText='Loading segmentations...'
            searchPromptText='Search by name or status'
            columns={[
              {
                name:'name',
                width:35,
                filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                sortFunc:(a,b) => firstNonZeroOrOne([
                  alphabeticallySort(a.name, b.name),
                  daysSinceEpoch(b.activeFrom) - daysSinceEpoch(a.activeFrom)
                ]),
                renderCell:(item) => ( <span>{item.name}</span> )
              },
              {
                name:'status',
                width:10,
                filterFunc:(a,searchParam) => textContains(a.status,searchParam),
                sortFunc:(a,b) => firstNonZeroOrOne([
                  alphabeticallySort(a.status, b.status),
                  daysSinceEpoch(b.activeFrom) - daysSinceEpoch(a.activeFrom),
                  alphabeticallySort(a.name,b.name)
                ]),
                renderCell:(item) => ( <span>{capitalize(item.status)}</span> )
              }, 
              {
                name:'activeFrom',
                display:'Start Date',
                width:18,
                sortFunc:(a,b) => firstNonZeroOrOne([
                  daysSinceEpoch(b.activeFrom) - daysSinceEpoch(a.activeFrom),
                  alphabeticallySort(a.name,b.name)
                ]),
                renderCell:(item) => ( <span>{moment(item.activeFrom).format('h:mm a, MMM D, YYYY')}</span> )              
              },
              {
                name:'activeTo',
                display:'End Date',
                width:17,
                sortFunc:(a,b) => firstNonZeroOrOne([
                  daysSinceEpoch(b.activeTo) - daysSinceEpoch(a.activeTo),
                  alphabeticallySort(a.name,b.name)
                ]),
                renderCell:(item) => ( <span>{moment(item.activeTo).format('h:mm a, MMM D, YYYY')}</span> )              
              }         
            ]}
          />
        </Col>
      </Row>
    )
  }
}

export default ProviderSegmentationList;



// WEBPACK FOOTER //
// ./src/routes/ProviderSegmentationList/components/ProviderSegmentationList.js